import { IconHamburgerMediumOutline, IconCloseMediumOutline } from '@teamleader/ahoy';
import { translate } from '@teamleader/i18n';
import cx from 'classnames';
import React, { useContext } from 'react';

import Logo from './Logo';
import styles from './styles.css';
import useLogoPosition from '../../../Components/Context/Hooks/useLogoPosition';
import Box, { BoxProps } from '../../../Components/UI/Box';
import Branding from '../../../Components/UI/Branding';
import IconButton from '../../../Components/UI/IconButton';
import MobilePopup from '../../../Components/UI/MobilePopup';
import OverflowingFlexBox from '../../../Components/UI/OverflowingFlexBox';
import { Client } from '../../../Types/client';
import { Department } from '../../../Types/department';
import useGlobalContext from '../Context';
import { themeContext } from '../ThemeLoader';

interface MobileNavigationProps extends BoxProps {
  onOpen?: () => void;
  onClose?: () => void;
  isOpen?: boolean;
  department?: Department;
  client?: Client;
}

const MobileNavigation: React.FC<MobileNavigationProps> = ({
  onOpen,
  onClose,
  isOpen,
  department,
  client,
  children,
  ...rest
}) => {
  const canOpenNavigation = !!onOpen;
  const { logo, type } = useGlobalContext();
  const { theme } = useContext(themeContext);
  const { inNavigation } = useLogoPosition(canOpenNavigation);

  return (
    <Box
      element="nav"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      className={cx(styles['navigation'], styles['navigation--mobile'])}
      {...rest}
    >
      <Box display="flex" paddingLeft={4} paddingRight={2} paddingVertical={3} alignItems="center">
        <Logo name={department?.name} logoUrl={logo} />
        <h1 className={styles['department-name']}>{department?.name}</h1>
      </Box>
      {canOpenNavigation && (
        <IconButton
          paddingHorizontal={4}
          paddingVertical={3}
          className={styles['menu-button']}
          icon={<IconHamburgerMediumOutline className={styles['menu-icon']} />}
          onClick={onOpen}
          title={translate('actions.menu')}
        />
      )}
      {!canOpenNavigation && inNavigation && (
        <Branding
          className={styles['branding']}
          display="flex"
          size="small"
          theme={theme}
          language={client?.language}
          country={client?.country}
          type={type}
        />
      )}
      {isOpen && (
        <MobilePopup className={cx(styles['navigation'], styles['navigation--mobile'])} inverse>
          <Box
            display="flex"
            paddingLeft={4}
            paddingVertical={3}
            alignItems="center"
            className={styles['header--menu-open']}
          >
            <Logo name={department?.name} logoUrl={logo} />
            <h1 className={styles['department-name']}>{department?.name}</h1>
            <IconButton
              paddingHorizontal={4}
              paddingVertical={3}
              className={styles['close-button']}
              icon={<IconCloseMediumOutline className={styles['menu-icon']} />}
              onClick={onClose}
              title={translate('actions.close')}
            />
          </Box>
          <OverflowingFlexBox scrollableClassName={styles['scrollable']}>{children}</OverflowingFlexBox>
          {inNavigation && <Branding theme={theme} language={client?.language} country={client?.country} type={type} />}
        </MobilePopup>
      )}
    </Box>
  );
};

export default MobileNavigation;
